import { render, staticRenderFns } from "./FormInputPassword.vue?vue&type=template&id=65612971&scoped=true&"
import script from "./FormInputPassword.vue?vue&type=script&lang=js&"
export * from "./FormInputPassword.vue?vue&type=script&lang=js&"
import style0 from "./FormInputPassword.vue?vue&type=style&index=0&id=65612971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65612971",
  null
  
)

export default component.exports